<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <div>
      <el-form :model="form" :rules="rules" ref="form" class="setting-form" label-width="180px">
        <el-col :span="24">
          <el-form-item prop="phone" label="卡面卡号/手机号">
            <el-input v-model="form.phone" placeholder="请输入卡面卡号/手机号" @keyup.enter.native="search" clearable
                      class="search-input"
                      @clear="clear">
              <el-button type="primary" slot="append" @click="search">查询</el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-card class="box-card" v-loading="loading">
          <div class="form-item-title">会员卡信息</div>
          <el-col :span="8">
            <el-form-item prop="cardNum" label="卡面卡号">
              <el-input v-model="formInfo.cardNum" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="name" label="姓名">
              <el-input v-model="formInfo.name" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label="手机号">
              <el-input v-model="formInfo.phone" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="status" label="卡状态">
              <el-input v-model="formInfo.status" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="memberCategoryName" label="卡类型">
              <el-input v-model="formInfo.memberCategoryName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="storeName" label="开卡门店">
              <el-input v-model="formInfo.storeName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="balance" label="储值本金" class="form-item-style">
              <el-input v-model="formInfo.balance" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="givingMoney" label="赠送金额" class="form-item-style">
              <el-input v-model="formInfo.givingMoney" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="usableIntegral" label="剩余积分" class="form-item-style">
              <el-input v-model="formInfo.usableIntegral" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="createDttm" label="发卡时间">
              <el-input v-model="formInfo.createDttm" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div class="line"></div>
          </el-col>
          <el-col :span="24">
            <div class="form-item-title">充值记录</div>
          </el-col>
          <list-operation ref="listOperation" :tableOptions="listColumns"
                          @selectRowChange="selectShowChange"></list-operation>
          <el-col :span="24">
            <div class="form-item-title">充值操作</div>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="refundMoney" label="反充金额">
              <el-input-number :min="0" :precision="2" v-model="form.refundMoney"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="payType" label="付款方式">
              <el-select v-model="payType" placeholder="请选择">
                <el-option label="现金" :value="10"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label=""></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="refundGivingMoney" label="反充赠送金额">
              <el-input-number :min="0" :precision="2" v-model="form.refundGivingMoney"
                               v-loading="moneyLoading"></el-input-number>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="" label=""></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="remarks" label="备注">
              <el-input type="textarea" :rows="2" v-model="form.remarks"></el-input>
            </el-form-item>
          </el-col>
        </el-card>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="submitData">提交</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../../config/api";
  import listOperation from '@/components/template/listOperationPage';

  export default {
    components: {
      listOperation
    },
    data() {
      return {
        moneyLoading: false,
        loading: false,
        payType: 10,
        formInfo: {
          cardNum: '',//卡号
          password: '',
          name: '',
          phone: '',
          memberCategoryId: '',
          status: '',
          giveIntegral: '',
          memberCategoryName: '',
          balance: '',
          storeId: '',
          createDttm: '',
          payType: 10,
          storeName: '',
          givingMoney: '',
        },
        form: {
          phone: '',
          id: '',
          memberCategoryId: '',//会员类型
          refundMoney: 0.00,//充值金额
          refundGivingMoney: 0.00,
          giveIntegral: 0,//赠送积分
          remarks: '',
        },
        rules: {
          phone: [{required: true, message: '请输入卡面卡号或手机号', trigger: 'blur'}],
          refundMoney: [{required: true, pattern: this.$utils.reg.thanNum, message: '请输入合法金额', trigger: 'blur'}],
          refundGivingMoney: [{required: false, pattern: this.$utils.reg.thanNum, message: '请输入合法金额', trigger: 'blur'}],
        },
        title: '',
        storeList: [],
        listColumns: {
          showSelect: true,
          // hideSum: true,
          summaryColumns: ['depositMoney', 'givingMoney'],
          columns: [
            {label: '序号', type: 'index', width: 80, prop: 'idx'},
            {
              label: '充值流水号',
              prop: 'billOrderNo',
              width: '180',
              align: "center",
            },
            {
              label: "实付金额",
              prop: "depositMoney",
              width: '120',
              align: "center",
            },
            {
              label: "赠送金额",
              prop: "givingMoney",
              width: '90',
              align: "center"
            },
            {
              label: '付款方式',
              width: '90',
              prop: 'payTypeName',
              align: "center",
            },
            {
              label: '充值日期',
              width: '125',
              prop: 'createDttm',
              align: "center"
            },
            {
              label: '备注',
              width: '90',
              prop: 'remarks',
              align: "center"
            }
          ],
          url: api.member.rechargeRecord,
          param: {}
        },


      };
    },
    computed: {
      statusList() {
        return this.$utils.getCacheStatus('mbMember.status')
      },
    },
    created() {
    },
    mounted() {
      this.title = document.title;
      this.getStoreList()
    },
    methods: {
      // 获取门店
      getStoreList() {
        this.$axios.fetchPost(api.store.store + '/list',).then(res => {
          if (res.code === 200) {
            res.data.unshift({id: -1, name: "总部"});
            this.storeList = res.data
          } else {
            this.$message({type: 'error', message: res.msg});
          }
        }).catch(err => {
          this.$message({type: 'error', message: '获取失败!'});
        })
      },
      // 查询
      search() {
        if (!this.form.phone) {
          this.$message({type: 'warning', message: '请输入卡面卡号/手机号'});
          return false;
        }
        this.loading = true
        this.clear();
        this.$axios.fetchPost(api.member.mbMemberQuery, {phone: this.form.phone}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.formInfo = res.data
              this.form.id = res.data.id
              this.form.memberCategoryId = res.data.memberCategoryId
              this.formInfo.status = this.statusList.filter(v => v.id === res.data.status)[0].label
            }
          } else {
            this.$message.error('[' + res.code + ']' + res.errorMsg)
          }
        }).finally(() => {
          this.loading = false
        })
        //查询充值记录
        let params = {};
        params.otherName = this.form.phone;
        params.pageNumber = 0;
        params.pageSize = 10;
        this.listColumns.param.otherName = this.form.phone;
        this.$refs['listOperation'].getTableData(params);
      },
      clear() {
        this.formInfo = {}
        this.form.id = ''
        this.form.memberCategoryId = ''
        this.form.refundMoney = 0.00
        this.form.refundGivingMoney = 0.00
        this.form.giveIntegral = 0
        this.form.remarks = ''
        this.form.payType = 10
      },
      // 提交
      submitData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            if (this.form.refundMoney > this.formInfo.balance) {
              this.$message.warning("反充金额不能大于储值本金");
              return false;
            }
            if (this.form.refundGivingMoney > this.formInfo.givingMoney) {
              this.$message.warning("反冲赠送不能大于赠送金额");
              return false;
            }
            let total = Number(this.form.refundMoney) + Number(this.form.refundGivingMoney);
            if (0 === total) {
              this.$message.warning("反冲金额不能为0.00");
              return false;
            }
            this.$confirm('确认提交？')
              .then(_ => {
                this.$loading({text: '提交中，请稍后。。。'});
                this.$axios.fetchPost(api.member.reverseRecharge, this.form).then(data => {
                  if (data.code === 200) {
                    if (data.data) {
                      this.search()
                    }
                    this.$notify({
                      type: "success",
                      title: '提交操作',
                      message: '成功',
                      showClose: false,
                    });
                    // this.$message({type: 'success', message: '操作成功'});
                  } else {
                    this.$notify({
                      type: "success",
                      title: '提交操作',
                      message: '失败',
                      showClose: false,
                    });
                  }
                }).catch((err) => {
                  this.$notify({
                    type: "success",
                    title: '提交操作',
                    message: '失败',
                    showClose: false,
                  });
                }).finally(() => {
                  this.$loading({}).close()
                })
              })
              .catch(_ => {
              });
          } else {
            return false
          }
        })
      },
      // 重置
      reset() {
        this.form = {}
        this.clear()
        this.$refs.form.resetFields()
      },
      selectShowChange(selectRows) {
        let money = 0;
        let givingMoney = 0;
        selectRows.map(item => {
          money = money + parseFloat(item.depositMoney);
          givingMoney = givingMoney + parseFloat(item.givingMoney);
        });
        this.form.refundMoney = money;
        this.form.refundGivingMoney = givingMoney;
      }
    }
  };
</script>
<style scoped>
  .page-template {
    padding: 16px 30px;
  }

  .page-title {
    text-align: center;
    padding-bottom: 10px;
  }

  .form-item-title {
    padding-bottom: 10px;
    font-weight: bold;
  }

  .box-card {
    padding-bottom: 20px;
  }

  .line {
    border-top: 1px dashed #e0dddd;
    margin-bottom: 20px;
  }

  .foot {
    padding: 20px;
    text-align: center;
  }

  /*去掉箭头*/
  /deep/ .numrule input::-webkit-outer-spin-button,
  /deep/ .numrule input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
  }

  /deep/ .numrule input[type="number"] {
    -moz-appearance: textfield;
  }

  /*单条搜索后面跟的搜索按钮*/
  .search-input {
    width: 280px;
    line-height: normal;
  }

  >>> .el-input-group__append, .el-input-group__prepend {
    background-color: #458cff;
    color: #fff;
    border-color: #458cff;
    font-weight: 700;
  }

  >>> .el-input.is-disabled .el-input__inner {
    color: #999;
    background-color: #f9f9f9;
  }

  .form-item-style >>> .el-form-item__label {
    color: red;
  }
</style>




// WEBPACK FOOTER //
// src/page/member/ecard/ReverseRecharge.vue